import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireFunctions } from '@angular/fire/functions';
import { QuizService } from 'src/app/quiz/quiz.service';
import { Router } from '@angular/router';
import { LoadingDialogComponent } from 'src/app/loading-dialog/loading-dialog.component';

@Component({
  selector: 'app-tests',
  templateUrl: './tests.component.html',
  styleUrls: ['./tests.component.scss']
})
export class TestsComponent implements OnInit {
  tests: any[] = [];
  loggedInUser: any;
  currentTimestamp = new Date().getTime();
  constructor(
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private quiz: QuizService,
    private router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private fsFuncs: AngularFireFunctions,
    public zone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    const dialogRef = this.dialog.open(LoadingDialogComponent, {
      disableClose: true
    })
    setInterval(() => {
      this.currentTimestamp = new Date().getTime();
    }, 1000 * 60)
    auth.onAuthStateChanged(async (userInfo) => {
      this.loggedInUser = userInfo;
      
      this.loggedInUser = userInfo;
      this.getUserTests().then(() => dialogRef.close())
    })
  }

  ngOnInit(): void {
  }
  async getUserTests() {
    for (let s of (await this.firestore.collection(`users/${this.loggedInUser.uid}/subjects`).get().toPromise()).docs) {
      const testSnaps = await this.firestore.doc(`tests/${s.id}/`).get().toPromise();
      let tests = [];
      if(testSnaps.exists)
      tests = await Promise.all(testSnaps.data().tests.map((t) => {
        return new Promise(async (resolve, reject) => {
          let test = t;
          t.startTime = 1715421600000;
          console.log(this.currentTimestamp, t.startTime)
          t.subject = s.data();
          t.subject.id = s.id
          t.instances = await (await this.firestore.collection(`users/${this.loggedInUser.uid}/tests/${test.id}/instances`).get().toPromise()).docs.map(i => {
            let instance = i.data();
            instance.instanceID = i.id;
            instance.created = new Date(instance.createTimestamp)
            return instance
          })
          resolve(test);
        })
      }))
      this.tests = this.tests.concat(tests)
    }
    console.log(this.tests);
  }
  async selectTest(test) {
    try {
      
    const dialogRef = this.dialog.open(LoadingDialogComponent, {
      disableClose: true
    })
      test.createTimestamp = new Date().getTime();
      delete test.instances
      let ref = await this.firestore.collection(`users/${this.loggedInUser.uid}/tests/${test.id}/instances`).add(test)
      await this.firestore.doc(`users/${this.loggedInUser.uid}/tests/${test.id}/`).set({test:true});
      this.quiz.selectTest(await (await this.firestore.doc(`users/${this.loggedInUser.uid}/tests/${test.id}/instances/${ref.id}`).get().toPromise()).data());
      this.quiz.setRef(this.firestore.doc(`users/${this.loggedInUser.uid}/tests/${test.id}/instances/${ref.id}`).ref);
      this.quiz.setSubjectRef(this.firestore.doc(`users/${this.loggedInUser.uid}/subjects/${test.subject.id}`).ref);
     await  this.router.navigateByUrl('test')
      dialogRef.close()
    } catch (err) {
      console.log(err)
    }
  }
  async selectInstance(instance) {
    try {
      const dialogRef = this.dialog.open(LoadingDialogComponent, {
        disableClose: true
      })
      this.quiz.selectTest(instance);
      await this.router.navigateByUrl('test')
      dialogRef.close()
    } catch (err) {
      console.log(err)
    }
  }

}
